import { useSuspense } from "@api";
import type { TSanctionConsequenceType, TSanctionOrigin, TSanctionStatus } from "@bbj-types/sanction";
import type { ObjectId } from "@bbj-types/utils";
import type { IDateRange } from "@styleguide";
import { axiosCandidateInstanceV2 } from "./axios";

export type TSanction = {
  _id: ObjectId;
  idConsequenceSanction: string;
  type: TSanctionConsequenceType;
  status: TSanctionStatus;
  origin: TSanctionOrigin;
  modified: boolean;
  candidate: {
    _id: ObjectId;
    firstName: string;
    lastName: string;
  };
  hzRequestAuthor: {
    _id: ObjectId;
    firstName: string;
    lastName: string;
  };
  createdAt: Date;
  updatedAt: Date;
};

export type IGetSanctionListAllResponse = Record<TSanctionStatus, TSanction[]>;

export type IGetSanctionListAllResponseItem = IGetSanctionListAllResponse[keyof IGetSanctionListAllResponse][number];

export interface IGetSanctionListAllSuspenseParams {
  status?: TSanctionStatus[];
  period?: IDateRange;
}

export const useGetSanctionListAllSuspense = (params?: IGetSanctionListAllSuspenseParams) => {
  return useSuspense(
    () =>
      axiosCandidateInstanceV2.get<IGetSanctionListAllResponse>("/sanctions", {
        withCredentials: true,
        params,
      }),
    [params]
  );
};
